/**
 * @fileoverview Target assignee choices query hook.
 * @description Wraps GET /sales/targets/eligible-assignees in a TanStack query. Only a Super Admin,
 * Sales Head or Sales Manager gets choices (an Executive is refused), so the query stays idle
 * unless `enabled`.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getEligibleTargetAssignees } from '@/features/sales/services/sales-targets.service'

/**
 * @description Fetches the Managers and Executives the caller may give a target to.
 * @param {boolean} enabled - Whether to fetch at all.
 * @returns {ReturnType<typeof useQuery>} The query (data is the choices).
 */
export function useEligibleTargetAssignees(enabled: boolean) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.eligibleAssignees,
    queryFn: getEligibleTargetAssignees,
    enabled,
  })
}
